import { alpha, useTheme } from "@mui/material/styles";
import { Fragment, type ReactNode } from "react";

import { splitContentWithSkillSlugs } from "./selectedSkillContext";

/** Display-only: render `/slug` tokens with a light primary tint (not bold). */
export function ScoutSkillSlugText({
  text,
  knownSlugs,
}: {
  text: string;
  /** Only tint these catalog slugs; avoids treating in-progress `/que` as a token. */
  knownSlugs?: ReadonlySet<string>;
}): ReactNode {
  const theme = useTheme();
  const parts = splitContentWithSkillSlugs(text, knownSlugs);
  if (parts.length === 1 && parts[0]?.type === "text") {
    return text;
  }
  const tint = alpha(theme.palette.primary.main, 0.85);
  return parts.map((part, index) =>
    part.type === "skillSlug" ? (
      // Plain span: MUI Box can inject layout styles that desync the caret overlay.
      <span key={`skill-${index}-${part.value}`} style={{ color: tint, fontWeight: "inherit" }}>
        {part.value}
      </span>
    ) : (
      <Fragment key={`text-${index}`}>{part.value}</Fragment>
    )
  );
}
